import { useCustomQuery } from "@/hooks/useCustomQuery"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  IconButton,
  Divider,
} from "@mui/material"
import { useParams, Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import LetterAvatar from "@/components/Avatar/LetterAvatar"
import { DetailTable } from "@/components/Tables/DetailTable"
import { columns } from "@/pages/products/Columns"

const SupplierDetails = () => {
  const { id } = useParams()

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useCustomQuery(["supplier-detail", id], `supplier/${id}`)

  if (isLoading) {
    return <div>Loading...</div>
  }

  const supplier = response?.data

  return (
    <div>
      <div className="breadcrumb-card">
        <h5>Supplier Details</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="//">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/suppliers">Suppliers</Link>
          </li>
          <li>{supplier.name}</li>
        </ul>
      </div>
      {supplier ? (
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-4 xxl:tw-grid-cols-5 tw-gap-6">
          <div className="card bg-white border-0 px-4 rounded-3 mb-4 lg:col-span-3 xxl:col-span-4">
            <p className="my-5 text-base font-semibold text-black">Products</p>

            <CrudProvider>
              <SupplierTable supplier={supplier} isLoading={isLoading} />
            </CrudProvider>
          </div>
          <div className="card bg-white border-0 ps-5 rounded-3 mb-4">
            <div className="card-body p-4">
              <div className="flex align-items-center mb-3 mb-lg-4">
                <div className="flex align-items-center">
                  <DetailAvatar name={supplier.name} />
                </div>
              </div>

              <div className="mb-3">
                <p>Code:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {supplier.code}
                </span>
              </div>

              <div className="mb-3">
                <p>Pan Number:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {supplier.pan_number ? supplier.pan_number : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Address:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {supplier.address ? supplier.address : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Contact Person:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  <LetterAvatar name={supplier.contact_person} />
                </span>
              </div>

              <div className="mb-3">
                <p>Phone:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {supplier.phone ? supplier.phone : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Email:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  {supplier.email ? supplier.email : "N/A"}
                </span>
              </div>

              <div className="mb-3">
                <p>Created By:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  <LetterAvatar name={supplier.createdBy.name} />
                </span>
              </div>

              <div className="mb-3">
                <p>Updated By:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  <LetterAvatar name={supplier.updatedBy.name} />
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>No Supplier data found.</div>
      )}
    </div>
  )
}
function SupplierTable({ supplier, isLoading }) {
  return (
    <>
      <DetailTable
        columns={columns}
        data={supplier.products}
        isLoading={isLoading}
      />
    </>
  )
}

export default SupplierDetails
